import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-amount-filter',
    templateUrl: './amount-filter.component.html',
    styleUrls: ['./amount-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AmountFilterComponent {
  @Input() filter: InternalFilterGroup;
  dataToView: FilterItem[] = [];
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.filter) {
      this.dataToView = UtilityFunctions.DeepClone(this.filter.data);
    }
  }

}
